import { useState } from 'react';
import { getFullName } from '../../../../../Apis/functions';
import { EmailSubsectionChip, PersonChip, PhoneSubsectionChip } from '../../../../../components/buttons/IconButtons';
import CustomTooltip from '../../../../../components/CustomTooltip';
import { getAllroleEmployeesPageable } from '../../../../../reduxToolkit/EmployeeRoles/EmployeeRolesApi';
import CustomCard from '../../../../../components/CustomCard';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import SelectedUserEmailPhoneCard from '../../../../../components/CustomAvailableAssignedItems/SubComponents/SelectedUserEmailPhoneCard';
import { EMPLOYEE_CONFIG_MODEL } from '../Model/AllowedModules';

/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */

export const AssignedPrivilegeEmployeesApp = ({
    selected,
    setSelected,
    selectForDelete,
    setSelectForDelete,
    setIsAllChecked,
    id,
}) => {
    const { t } = useTranslation();

    const [deleteModalShow, setDeleteModalShow] = useState(false);


    const dynamicConfig = EMPLOYEE_CONFIG_MODEL;

    const hide = () => {
        setSelectForDelete([]);
        setIsAllChecked(false);
        setDeleteModalShow(false);
    };

    return {
        t,
        deletePermission: false,
        deleteModalShow,
        dynamicConfig,
        assignedEndPoint: getAllroleEmployeesPageable,
        buildBody: ({ page, rowsPerPage, searchElement }) => ({
            id,
            key: searchElement,
            pagination: {
                page,
                size: rowsPerPage,
            },
        }),
        hide,
    };
};
